// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__XCVYy","info":"UpdateTermsInfo_info__278iF"};